var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMakeUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512.002 512.002",
    height: 512,
    viewBox: "0 0 512.002 512.002",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m350 236.025c0-96.495-78.505-175-175-175s-175 78.505-175 175c0 60.264 30.621 113.51 77.12 145h-62.12c-8.284 0-15 6.716-15 15v10c0 35.841 29.159 65 65 65h220c35.841 0 65-29.159 65-65v-10c0-8.284-6.716-15-15-15h-62.12c46.499-31.49 77.12-84.736 77.12-145zm-30.356 175c-2.434 16.939-17.042 30-34.644 30h-220c-17.602 0-32.21-13.061-34.644-30zm-144.644-30c-79.953 0-145-65.047-145-145s65.047-145 145-145 145 65.047 145 145-65.047 145-145 145z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220.962 211.276-70.71 70.71c-5.858 5.858-5.858 15.355 0 21.213 2.929 2.929 6.768 4.394 10.606 4.394s7.678-1.464 10.606-4.394l70.71-70.71c5.858-5.858 5.858-15.355 0-21.213-5.857-5.858-15.355-5.858-21.212 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.749 168.85c-5.857-5.858-15.355-5.858-21.213 0l-70.71 70.71c-5.858 5.858-5.858 15.355 0 21.213 2.929 2.929 6.768 4.394 10.606 4.394s7.678-1.464 10.606-4.394l70.71-70.71c5.858-5.858 5.858-15.355.001-21.213z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m504.631 66.748c-58.146-34.36-117.115-34.36-175.262 0-6.661 3.937-9.235 12.293-5.944 19.295l48.575 103.332v236.65c0 24.813 20.187 45 45 45s45-20.187 45-45v-236.65l48.575-103.332c3.291-7.002.717-15.359-5.944-19.295zm-72.631 164.277h-30v-30h30zm-15 210c-8.271 0-15-6.729-15-15v-165h30v165c0 8.271-6.729 15-15 15zm20.477-270h-40.953l-39.934-84.95c40.537-20.108 80.283-20.108 120.82 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakeUp);
export default __webpack_public_path__ + "static/media/make-up.9c4bf5941ba3794a17a7b7162f8b642b.svg";
export { ForwardRef as ReactComponent };